const THEME = {
  COLOR: {
    PRIMARY: 'darkturquoise',
    SECONDARY: '#FFF',
    SECONDARY_HOVER: '#eee',
    BLACK: '#000',
    INVERT_0: '#959595',
    INVERT_1: '#282c34',
    INVERT_2: '#20232a',
    INVERT_3: '#16181d',
    FILL_1: '#888',
    LIGHT_1: 'rgb(247 247 247)'
  },
  FONT: {
    SIZE: {
      LARGE: 28,
      MEDIUM: 24,
      SMALL: 20,
    },
    FAMILY: {
        PRIMARY: 'Montserrat',
        SECONDARY: 'Roboto',
    }
  },
  MEDIA: {
    DESKTOP: '',
    TABLET: '820px',
    MOBILE: ''
  }
};

export default THEME;